import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AppServiceService } from './app-service.service';
//import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'TouchFree Waiter';
  load: boolean = false;
  usermode: boolean = false;
  homepage: boolean = false;
  loginstatus: boolean;
  selectedTab: Number;
  navlist = [{ 'href': '/#/home', 'title': 'Home' },
  { 'href': '/#/menu-dashboard', 'title': 'Catalog' },
  { 'href': '/#/qrcode', 'title': 'QR Code' },
  { 'href': '/#/about', 'title': 'About' },
  { 'href': '/#/login', 'title': 'Login' },
  { 'href': '/#/', 'title': 'Logout' }]

  constructor(public cookie: CookieService, public service: AppServiceService) {
    this.loginstatus = this.service.loginstatus;
  }
  ngOnInit() {
    // if(!environment.production)
    //     debugger
  }
  navHeader(index) {
    if(index == 0){
      this.homepage = true;
    }
    else{
      this.homepage = false;
    }
    if (index == 5) {
      this.logout();
      this.selectedTab = 0;
      this.homepage = true;
    }
    else
      if (!this.loginstatus && index != 0 && index != 3) {
        localStorage.setItem("currenttab", '4')
        this.selectedTab = parseInt(localStorage.getItem('currenttab'))
      }
  }
  logout() {
    this.loginstatus = this.service.loginstatus = false;
    this.cookie.delete('LoginUser')
  }
  ngOnChanges() {

  }
  getbackground()
  {
    const queryString = window.location.hash;
    
    const page_type = queryString.split(/[\?/=]+/)
    if (page_type[1] == 'home' || page_type[0] == '' ) {
      this.homepage = true;
      return true;
    }
    return false;
  }

}
